module.exports = __webpack_public_path__ + "static/media/gaia-mi.4c8859ad.png";